export const AGENT_CHAT_IMAGES_FEATURE_FLAG = 'agent-chat-images';

export const BUCKET_COUNT = 10_000;
